import { router } from "expo-router";

import { authClient } from "~/utils/auth";

export const logout = () => {
  return authClient.signOut({
    fetchOptions: {
      onSuccess: () => {
        router.push("/auth");
      },
    },
  });
};
